import { createI18n } from 'vue-i18n'
import hr from './locales/hr'
import en from './locales/en'

const flattenMessages = (nestedMessages: Record<string, any>, prefix = ''): Record<string, string> => {
  return Object.keys(nestedMessages).reduce((messages: Record<string, string>, key) => {
    const value = nestedMessages[key]
    const prefixedKey = prefix ? `${prefix}.${key}` : key

    if (typeof value === 'object' && value !== null) {
      Object.assign(messages, flattenMessages(value, prefixedKey))
    } else {
      messages[prefixedKey] = value
    }

    return messages
  }, {})
}

const countAllKeys = (obj: Record<string, any>): number => {
  let count = 0;

  for (const key in obj) {
    count++;
    if (typeof obj[key] === 'object' && obj[key] !== null) {
      count += countAllKeys(obj[key]);
    }
  }

  return count;
}

const flattenedHr = flattenMessages(hr)
const flattenedEn = flattenMessages(en)

const savedLocale = localStorage.getItem('locale') || 'hr'
const validatedLocale = ['hr', 'en'].includes(savedLocale) ? savedLocale : 'hr'

const messages = {
  hr,
  en
}

const i18n = createI18n({
  legacy: true,
  locale: validatedLocale,
  fallbackLocale: 'hr',
  messages,
  silentTranslationWarn: false,
  missingWarn: false,
  fallbackWarn: false
})

const translate = (key: string, locale: string | { value: string } = validatedLocale): string => {
  const currentLocale = typeof locale === 'string' ? locale : locale.value;
  const flattenedMessages = currentLocale === 'hr' ? flattenedHr : flattenedEn;
  return flattenedMessages[key] || key;
}

if (typeof window !== 'undefined') {

  const originalT = i18n.global.t;
  i18n.global.t = (key: string, ...args: any[]): string => {
    const result = translate(key);
    return result;
  };
}

if (typeof window !== 'undefined') {
  const windowObj = window as any

  windowObj._i18nDebug = {
    getLocale: () => i18n.global.locale,
    setLocale: (locale: string) => {

      (i18n.global.locale as any) = locale
      localStorage.setItem('locale', locale)
    },
    translate,
    getFlattened: () => {
      return {
        hr: flattenedHr,
        en: flattenedEn
      }
    },

    testTranslation: (key: string) => {

      return {
        hr: flattenedHr[key],
        en: flattenedEn[key],
        hrDirect: flattenedHr[key],
        enDirect: flattenedEn[key]
      }
    }

  }

  setTimeout(() => {
    const testKeys = ['establishments.title', 'navigation.dashboard', 'app.title'];

    testKeys.forEach(key => {
      const test = windowObj._i18nDebug.testTranslation(key);

      if (test.hr !== test.hrDirect) {

      }

      if (test.en !== test.enDirect) {

      }
    });
  }, 500)
}

function installGlobalMixin() {
  const app = (i18n as any).app;
  if (app) {
    app.mixin({
      methods: {
        $t(key: string): string {
          return translate(key, i18n.global.locale);
        }
      }
    });
  }
}

const originalInstall = i18n.install;
i18n.install = (app, ...options) => {
  originalInstall.call(i18n, app, ...options);

  app.config.globalProperties.$t = (key: string, ...args: any[]): string => {
    return translate(key, i18n.global.locale);
  };
};

export default i18n